import React from "react";

const MamaDaiIntroduction = ({courseData}) => {

    if(!courseData || (courseData && !courseData.introduction)){
        return false
    }
    return <div className="introduction-block">
        <div dangerouslySetInnerHTML={{ __html: courseData.introduction }}></div>
    </div>
}

export default MamaDaiIntroduction;